import React from "react";
import { Outlet } from "react-router-dom";
import EmployerNav from "../EmployerNav/EmpNav";
import EmployerFooter from "../../Main/Footer/Footer";

export default function EmployerLayout() {
  return (
    <>
      <EmployerNav />
      <Outlet />
      <EmployerFooter />
    </>
  );
}
